import React from 'react';

import { ISplitModuleFields } from '@/types/contentful';

import { BlockContainer, Layout, Column } from '../Layout';
import { VariationContainer } from '../VariationContainer';

// Split modules
import { AssetWithText } from './AssetWithText';
import { Form } from './Form';

export function SplitModule({ id, modules }: ISplitModuleFields) {
  return (
    <BlockContainer
      id={id}
      marginTop={{
        0: 'blockMarginY_tablet',
        desktop: 'blockMarginY_desktop'
      }}
      marginBottom={{
        0: 'blockMarginY_tablet',
        desktop: 'blockMarginY_desktop'
      }}
      data-testid="split-module"
    >
      <Layout
        gutter={{ 0: 0, tablet: 'ml' }}
        flexDirection={{
          0: 'column',
          tablet: 'row'
        }}
      >
        {modules.map(({ sys, fields }: any) => (
          <Column key={sys?.id} size={{ min: 12, tablet: 6 }} marginBottom="l">
            {(() => {
              switch (sys?.contentType?.sys?.id) {
                case 'splitAssetWithText':
                  return <AssetWithText {...fields} />;

                case 'splitForm':
                  return <Form {...fields} />;

                case 'variationContainer':
                  return <VariationContainer {...fields} sysId={sys?.id} />;

                default:
                  return null;
              }
            })()}
          </Column>
        ))}
      </Layout>
    </BlockContainer>
  );
}
